import { request } from '@/utils/request'
import Desk from '@/models/desk'

export function getDesks () {
  return request({
    url: 'desks',
    method: 'get'
  }).then(response => {
    return response.map(item => Desk.createItem(item))
  })
}
